import { adjustmentType } from './enums';
import { BlueprintInstanceType } from '../shared.enums';
import { NotificationType } from '../notifications/enums';
import { accessoryData } from './accessory.data';

import { Publish } from '../../decorators';
import { KitchenDesignBase, KitchenDesignOptions } from '../kitchen-design-base';

import { AccessoryAssetData, AccessoryData, AccessoryDataIn } from './types';

export class Accessory extends KitchenDesignBase<AccessoryDataIn> {
	#sku: string;
	#description: string;
	#msrp: number;
	#pairedComponentSku: Array<string>;
	#assetData: AccessoryAssetData;
	#totalAdjustment: number;
	#hsProductId: string | null;

	constructor (options: KitchenDesignOptions<AccessoryDataIn> = {}) {
		super(BlueprintInstanceType.PromotionalSku, options);
		const { dataIn = null } = options;
		const data = accessoryData(dataIn);

		this._id = data.id;
		this.#sku = data.sku;
		this.#description = data.description;
		this.#msrp = data.msrp;
		this.#pairedComponentSku = data.pairedComponentSku;
		this.#hsProductId = data.hsProductId ?? null;

		this.setInitialized();
	}

	set sku (sku: string) { this.#sku = sku; }
	get sku (): string { return this.#sku }

	set description (description: string) { this.#description = description; }
	get description (): string { return this.#description }

	get pairedAppliance (): Array<string> { return this.#assetData?.pairedAppliance ?? null }
	get isValid (): boolean {
		const notifications = this.getNotications();
		return notifications.every((notification) => notification.type === NotificationType.Info || notification.acceptedBy !== null);
	}

	get msrp (): number { return this.#msrp }

	get hsProductId (): string | null { return this.#hsProductId }

	get totalAdjustment (): number { return this.#totalAdjustment }
	set totalAdjustment (totalAdjustment: number) { this.#totalAdjustment = totalAdjustment; }

	// serialize
	public serialize (): AccessoryData {
		return {
			id: this._id,
			sku: this.#sku,
			description: this.#description,
			msrp: this.#msrp,
			pairedComponentSku: this.#pairedComponentSku
		};
	}
}
